import { Button } from 'antd';
import styled from 'styled-components';

export const ModalContainer = styled.div``;

export const Content = styled.div`
  > span {
    display: flex;
    position: relative;

    h1 {
      color: ${({ theme }) => theme.background};
      font-weight: 600;

      background: ${({ theme }) => theme.menuButton};
      padding: 10px;
      width: 100%;
    }

    button {
      position: absolute;
      background: transparent;
      top: 16px;
      right: 16px;

      svg {
        color: #fff;
      }
    }
  }

  > div {
    padding: 20px;

    .ant-switch-inner {
      font-size: 1.25rem;
    }
    .ant-switch,
    .ant-switch-checked {
      height: 32px;
    }

    .ant-switch-handle {
      top: 20%;
    }

    .ant-switch-checked {
      background: ${({ theme }) => theme.menuButton};
    }

    p {
      display: flex;
      font-size: 1.75rem;
      color: #6e7174;

      .ant-input:focus {
        border-color: ${({ theme }) => theme.menuButton};
        outline: 0;
        -webkit-box-shadow: 0 0;
        box-shadow: 0;
      }

      input {
        border: 0;
        padding: 0;
        border-bottom: 2px solid ${({ theme }) => theme.menuButton};
        margin-left: 6px;
        font-size: 1.75rem;

        &:hover {
          border-color: ${({ theme }) => theme.menuButton};
        }
      }
    }
  }
`;

export const CustomButton = styled(Button)`
  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9);
  }
`;
